import { render, staticRenderFns } from "./SlotsSelection.vue?vue&type=template&id=4743630e&"
import script from "./SlotsSelection.vue?vue&type=script&lang=js&"
export * from "./SlotsSelection.vue?vue&type=script&lang=js&"
import style0 from "./SlotsSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports